export default {
  STATE_INIT: 0,
  STATE_BEGIN: 1,
  STATE_DONE: 2,
  STATE_FAIL: 3
};
